import React, { useState } from 'react';

import { Input, InputAdornment, Typography } from '@mui/material';
import { PanelHeader } from 'src/components/generic/PanelHeader';
import { SearchIcon } from 'src/components/icons/SearchIcon';
import { makeStyles } from 'tss-react/mui';

import { AddedApiDeckConnections } from './AddedConnections';
import { useBackToAI } from '../BackToAIButton';

const useStyles = makeStyles()(_theme => ({
  main: {
    flex: 1,
    overflow: 'auto',
  },
  wrapper: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
}));

export function IntegrationDrawer() {
  const { classes } = useStyles();
  const handleBackToAI = useBackToAI();

  return (
    <div className={classes.wrapper}>
      <PanelHeader
        showBackButton
        backButtonTooltip="Back to AI"
        text="Integrations"
        onClickBack={handleBackToAI}
      />
      <div className={classes.main}>
        <IntegrationBody />
      </div>
    </div>
  );
}

const useIntegrationBodyStyles = makeStyles()(theme => ({
  root: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    height: '100%',
    padding: theme.spacing(2),
  },
}));

export function IntegrationBody() {
  const { classes } = useIntegrationBodyStyles();
  const [searchText, setSearchText] = useState<string>('');

  return (
    <div className={classes.root}>
      <Typography>Connect an integration to import data into your documents.</Typography>
      <Input
        fullWidth
        placeholder="Search integrations..."
        startAdornment={
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        }
        value={searchText}
        onChange={e => setSearchText(e.target.value)}
      />
      <AddedApiDeckConnections searchText={searchText} />
    </div>
  );
}
